<template>
	<div>
		<!-- ADMIN SOLICITUDES  -->
		<div v-if="solicitudesDisponibles.length" >
			<simple-card-admin-finalizadas v-for="solicitud in solicitudesDisponibles" v-bind:key="solicitud.id" v-bind:cardInfo="solicitud"/>
		</div>
		<div v-else>
			<h4> No se tienen solicitudes pendientes.</h4>
		</div>
	</div>
</template>
<style lang="scss">

</style>
<script>
  import firebase from '../config'
	const { db } = firebase;
  import Modal from "../components/Modal"
	// import CardImg from '../components/CardImg.vue'
	import SimpleCardAdminFinalizadas from '../components/SimpleCardAdminFinalizadas.vue'
	// import NavBar from '../components/NavBar.vue'
	// import FloatBtn from '../components/FloatBtn.vue'
	// const dbTodos = firebase.database().ref('todos');
	// const allTodos = db.collection('todos')
	export default {
		name: "AdminSolFinalizadas",
		components: { SimpleCardAdminFinalizadas },
			data() {
				return {
          currentModal:null,
					solicitudesDisponibles:[],
					publicPath: process.env.BASE_URL,
					info: null
				};
			},
		firestore: {
				// solicitudesDisponibles: db.collection('todos'),
			},
		methods: { 
      openModal() {
        return this.$ionic.modalController
          .create({
						component: Modal,
						props:{ ModalModify:true, },
            componentProps: {
              data: {
								content: 'New Content',
								ModalModify:true,
              },
              propsData: {
								title: ' MODAL ADMIN',
								ModalModify:true,
              },
            },
          })
        .then(m => {
          this.currentModal = m;
          m.present()
        })
      },
			// openStart () {
			// 	document.querySelector('ion-menu-controller').open();
      //   document.querySelector('ion-menu').open('my-menu');
			// 	// console.log("Erroro");

			// },
			openEnd () {
				document.querySelector('ion-menu').open('end')
			},
			async getZipInfo(zip) {
				const res = await fetch(`https://api.zippopotam.us/us/${zip}`);
				if (res.status == 404) {
					this.showAlert();
				}
				this.info = await res.json();
			},
			clearInfo() {
				this.info = null;
			},
			showAlert(tit, msg) {
				return this.$ionic.alertController
					.create({
						header: tit,
						message: msg,
						buttons: ["OK"]
					})
					.then(a => a.present());
			},
		},
		mounted () {
			console.log(this.solicitudesDisponibles)
		},
		created () {
      let _self = this;
      let solicitudes = [];
      db.collection('todos')
      .where('finishHim', '==', true)
			.get()
        .then(function(querySnapshot) {
          querySnapshot.forEach( (doc) => {
            let _tpm = doc.data();
            _tpm.id  = doc.id;
            solicitudes.push(_tpm);
            // _self.re.id  = doc.id;
          });
          _self.solicitudesDisponibles =  solicitudes ;
          console.log(_self.solicitudesDisponibles);
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
				});
			// .onSnapshot(function(snapshot) {
			// 	snapshot.forEach(function(doc) {
      //       let _tpm = doc.data();
      //       _tpm.id  = doc.id;
      //       solicitudes.push(_tpm);
      //       // _self.re.id  = doc.id;
			// 		});
			// 		_self.solicitudesDisponibles =  solicitudes ;
			// 		console.log(solicitudes);
			// }, function(error) { console.log(error); });	
			
		}
	};
</script>